export { default } from "./ERC20Mint"
